module.exports = __webpack_public_path__ + "static/media/bg.3410334.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/common/audio/bg.mp3
// module id = TshJ
// module chunks = 13